import { CANDY_APPLE } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { Text } from 'foundations-components/components/Text';
import { forwardRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledBorderlessLabel = styled.span.withConfig({
  displayName: "DataTokenMarkTag__StyledBorderlessLabel",
  componentId: "bout55-0"
})(["font-size:", ";"], ({
  theme
}) => theme.typography['heading-100'].fontSize);
const StyledSpan = styled.span.withConfig({
  displayName: "DataTokenMarkTag__StyledSpan",
  componentId: "bout55-1"
})(["max-height:22px !important;line-height:", " !important;vertical-align:top !important;cursor:", ";"], ({
  theme
}) => theme.typography['heading-100'].lineHeight, ({
  $onClick
}) => $onClick ? 'pointer' : 'inherit');
const StyledTagSpan = styled.span.withConfig({
  displayName: "DataTokenMarkTag__StyledTagSpan",
  componentId: "bout55-2"
})(["", " cursor:", ";"], ({
  $verticalAlign
}) => $verticalAlign && css(["& > *{vertical-align:", " !important;}"], $verticalAlign), ({
  $onClick
}) => $onClick ? 'pointer' : 'inherit');
const getTagUse = ({
  isActive,
  isError,
  isHover
}) => {
  if (isError) return 'danger';
  if (isHover) return 'oz';
  if (isActive) return 'calypso';
  return 'default';
};
const DataTokenMarkTag = /*#__PURE__*/forwardRef(({
  'data-test-id': dataTestId = 'formula-editor-token',
  children,
  closeable,
  inline = true,
  isActive,
  isError = false,
  label,
  onClick,
  onCloseClick,
  propertyIconName,
  rightIcon,
  use = 'default',
  verticalAlign
}, ref) => {
  const [isHover, setIsHover] = useState(false);
  const tagUse = getTagUse({
    isActive,
    isError,
    isHover
  });
  const iconName = isError ? 'warning' : propertyIconName;
  const iconColor = isError ? CANDY_APPLE : undefined;
  return use === 'borderless' || use === 'multiSelectTag' ?
  /*#__PURE__*/
  // @bend-expect trellis-tokenized
  _jsxs(StyledSpan, {
    "data-error": isError,
    "data-test-id": dataTestId,
    "data-use": "borderless",
    onClick: onClick,
    ref: ref,
    $onClick: onClick,
    children: [iconName && /*#__PURE__*/_jsx(UIIcon, {
      className: "p-right-2",
      color: iconColor,
      name: iconName,
      size: 16
    }), use === 'multiSelectTag' ? label :
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledBorderlessLabel, {
      children: label
    }), rightIcon, children]
  }) :
  /*#__PURE__*/
  // @bend-expect trellis-tokenized
  _jsx(StyledTagSpan, {
    onClick: onClick,
    onMouseEnter: () => setIsHover(true),
    onMouseLeave: () => setIsHover(false),
    $onClick: onClick,
    $verticalAlign: verticalAlign,
    children: /*#__PURE__*/_jsx(Tag, {
      marginInline: inline ? '0' : undefined,
      closeable: closeable && !!onCloseClick,
      "data-error": isError,
      "data-test-id": dataTestId,
      "data-use": tagUse,
      inline: inline,
      onCloseClick: onCloseClick,
      maxInlineSize: "225px",
      truncateStringProps: {
        fixedChildren: rightIcon,
        tooltip: false
      },
      use: tagUse,
      children: /*#__PURE__*/_jsxs("span", {
        ref: ref,
        children: [iconName && /*#__PURE__*/_jsx(UIIcon, {
          className: "p-right-1",
          color: iconColor,
          name: iconName,
          size: 12
        }), /*#__PURE__*/_jsx(Text, {
          as: "span",
          typography: "heading-25",
          children: label
        }), children]
      })
    })
  });
});
export default DataTokenMarkTag;